const KNOWLEDGE_ZONE_SERVICE = 'kcService';

/**
 * Creates a Knowledge Zone service. This service helps to search for documents stored at Knowledge Zone service.
 * @param services List of services registered in application.
 * @returns An instance of Knowledge Zone service
 */
export default function kzServiceFactory(services) {

  let thisService = {
    getBUs,
    searchTutorials
  };

  return thisService;

  /**
   * Responsible for search Tutorials that have the provided text.
   * @param text To be searched.
   * @returns A list of Tutorials and the total tutorials found.
   */
  function searchTutorials(locale, bu, text) {
    //The query is included to create a different entry in the cache
    let path = 'Search?lang=' + locale + '&bu=' + bu + '&query=' + text;
    let data = {
        query: text
    };
    let config = {
      cache: true
    };

    return services.http.post(KNOWLEDGE_ZONE_SERVICE, path, data, config).then(resp => resp.data);
  }

  /**
   * Responsible for get the BU's of the user.
   * @returns A list of Bu's of the user.
   */
  function getBUs() {
    let path = 'bu';
    let config = {
      cache: true
    };
    return services.http.get(KNOWLEDGE_ZONE_SERVICE, path, config).then(resp => resp.data);
  }
}
